import NavBar from './NavBar'
import MovieList from './MovieList'
import { useState } from 'react'

const Profile = () => {
  const [isSelected, setSelected] = useState(false)
  const [isLoggedIn, setIsLoggedIn] = useState(false)

  const handleOnProfileClick = (e) => {
    setSelected(true)
    setIsLoggedIn(true)
  }

  return (
    <>
      {!isSelected ? (
        <>
          <br></br>

          <article className='users' onClick={() => handleOnProfileClick()}>
            <img src='https://avatars.githubusercontent.com/u/25799830?v=4'></img>
            <img src='https://media.wired.com/photos/5a580f19ad44960421dcf957/1:1/w_981,c_limit/blackpanther-featured_.jpg'></img>
            <img src='https://i.pinimg.com/originals/5f/96/f9/5f96f9adf79c0801ab9e684377da7d19.jpg'></img>
            <img src='https://i.pinimg.com/474x/f9/d8/a7/f9d8a70a2b527645ddb804bbbb336937.jpg'></img>
            <img src='https://i.pinimg.com/originals/31/96/10/31961066f6da752d2a086a70f0fd025f.jpg'></img>
            <h4>Stark</h4>
            <h4>T'Challa</h4>
            <h4>Peter</h4>
            <h4>Odinson</h4>
            <h4>Strange</h4>
          </article>
          <button className='manageProfileButton'>Manage Profiles</button>
        </>
      ) : null}

      {isLoggedIn ? <NavBar /> : null}
      {isLoggedIn ? <MovieList /> : null}
    </>
  )
}

export default Profile
